import React from 'react'
import { domToReact } from 'html-react-parser'
import HPSupportSpecificLink from '../components/HPSupportSpecificLink'

const builtInReplacerMap = {
  HP_SUPPORT_PRODUCT_LINK: HPSupportSpecificLink
}

/**
 * Resolves a single data-replacer node into a React element.
 * Supports both built-in replacers owned by this file and caller-provided replacements.
 *
 * @param {Object} params
 * @param {Object} params.domNode - The parsed DOM node being inspected.
 * @param {Object} params.parserOptions - html-react-parser options used to render nested children.
 * @param {Object.<string, React.ReactNode>} [params.replacements={}] - Caller-provided replacer mappings.
 * @returns {React.ReactNode|undefined} A replacement node, or undefined when the DOM node should be left unchanged.
 */
export const resolveReplacerTag = ({
  domNode,
  parserOptions,
  replacements = {}
}) => {
  if (!(domNode.type === 'tag' && domNode?.attribs?.['data-replacer'])) {
    return undefined
  }

  const replacerId = domNode.attribs['data-replacer']
  const BuiltInReplacer = builtInReplacerMap[replacerId]

  if (BuiltInReplacer) {
    return (
      <BuiltInReplacer>
        {domToReact(domNode.children || [], parserOptions)}
      </BuiltInReplacer>
    )
  }

  if (Object.prototype.hasOwnProperty.call(replacements, replacerId)) {
    return replacements[replacerId]
  }

  return undefined
}
